export const PAGINATION_SIZES = {
  pageSize: 25,
  pageIndex: 0,
};
export const MAX_REVENUE = 5_000;
export const WEBSITE_PREFIX = 'https://';

export const EQUAL_FILTERS = [
  'id',
  'orderId',
  'userId',
  'stageId',
  'statusId',
  'refContactId',
  'licenseeId',
  'salesRepId',
  'salesRepIds',
  'companyId',
  'dwellingType',
  'dwellingPurpose',
  'assigneeId',
  'createdById',
  'outsideSalesRepId',
  'accountManagerId',
  'processorId',
  'type',
  'status',
  'roleId',
  'payorId',
  'clientId',
  'serviceTypeId',
  'price',
  'providerId',
  'isLive',
  'isMuted',
  'isActive',
  'isDeleted',
  'frequencyType',
  'reportDay',
  'duration',
  'phoneCalls',
  'processOrders',
  'value',
  'emailCount',
  'state',
  'activitiesCount',
  'ordersCount',
  'usersNo',
  'team',
  'cancellationReasonId',
  'accountNumber',
  'nextActivityType',
  'languageId',
  'depositCollectedAmount',
  'referralCompanyId',
  'externalId',
  'rating',
  'isVisible',
  'isUrgent',
  'isPaid',
  'goalMonth',
  'messageTemplateId',
  'alternativeMessageTemplateId',
  'trigger',
  'priority',
  'displayOrder',
  'rulesCount',
  'useAlternativeTemplates',
  'aiIsEscalated',
  'isCallScheduled',
  'channelTypeId',
  'useInsideBusinessHours',
  'dontSend',
];

export const RANGE_FILTERS = [
  'created',
  'creationDate',
  'createdAt',
  'completedAt',
  'completed',
  'processedAt',
  'processed',
  'updated',
  'updatedAt',
  'revenue',
  'collectedRevenue',
  'internalRevenue',
  'projectedRevenue',
  'cancelledAt',
  'serviceStartDate',
  'serviceExpirationDate',
  'expirationDate',
  'closeDate',
  'closed',
  'closedAt',
  'lastActivity',
  'date',
  'elapsedTime',
  'moveInDate',
  'validTo',
  'goalStartDate',
  'goalEndDate',
  'lastSignedIn',
  'amount',
  'nextActivityTime',
  'nextActivityType',
  'stageChangedAt',
  'depositCollectedDate',
  'reviewDate',
  'createdDate',
  'paidDate',
  'paidAt',
  'chargebackDate',
  'orderCreatedDate',
  'createdAt',
  'lastUpdated',
  'nextScheduledCallTime',
] as const;

export type RangeFilter = (typeof RANGE_FILTERS)[number];

export const CURRENCY_SIGN = '$';

export const SALES_ROLE = '97e5f611-daaf-49a4-89ed-e7df89f821a2';

export const STAGE_COLORS = {
  Leads: '#9c27b0',
  Completed: '#4caf50',
  Processing: '#ff9800',
  Cancelled: '#f44336',
  Sales: '#3f51b5',
};

export const RANGE_NODE_WIDTH = 'calc(100% - 50px)';

export const TOKENS = [
  'User',
  'ClientName',
  'ClientEmail',
  'Address',
  'MoveInDate',
  'CloseDate',
  'Advisor',
  'AdvisorPhone',
  'Licensee',
  'ReferralContact',
  'ReferralCompany',
  'SubCompany',
] as const;

export const CONTRACT_LENGTHS = {
  items: [
    { id: 0, name: 'None' },
    { id: 12, name: '12 months' },
    { id: 18, name: '18 months' },
    { id: 24, name: '24 months' },
    { id: 36, name: '36 months' },
    { id: 48, name: '48 months' },
    { id: 60, name: '60 months' },
  ],
};

export const DWELLING_TYPES = {
  items: [
    { id: 1, name: 'House' },
    { id: 2, name: 'Apartment' },
  ],
};

export const PROVIDERS = {
  AmbitEnergy: 'Ambit Energy',
  IronHorse: 'IronHorse',
  Varsity: 'Varsity',
  Spectrum: 'Spectrum',
} as const;

export const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'DC',
  'AS',
  'GU',
  'MP',
  'PR',
  'VI',
];
